import React, { useState, useEffect } from 'react';
import { Badge, Breadcrumb, Button, Card, Col, Select, Table, Tag, Typography, theme, Flex, Row, message } from 'antd';
import { FileWordOutlined, CheckCircleOutlined, StarOutlined } from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
import WorkflowManagementAPI from '../../../restAPI/WorkflowManagementAPI';
import { useSelector } from 'react-redux';

const { Text } = Typography;

export default function InitiatorView() {

    const { companyId, token, userId } = useSelector(state => state.auth);

    const location = useLocation();
    const { objectDataToInitiatorView } = location.state || {};
    //console.log(objectDataToInitiatorView, 'objectDataToInitiatorView')
    const [list, setList] = useState([]);
    const [messageApi, contextHolder] = message.useMessage();

    const [editedRow, setEditedRow] = useState(null);
    const navigate = useNavigate();

    const [returnDataSource, setReturnDataSource] = useState([])

    const [abc, setABC] = useState([])

    const { token: { colorBgContainer, borderRadiusLG, colorPrimary }, } = theme.useToken();

    const goBack = () => {
        navigate(-1); // Navigate to the previous page
    };


    useEffect(() => {
        //console.log(userId, 'User Id')
        formatReturnData();
    }, [1]);

    function setReturnData(
        selectRow,
        approverId,
        approverName,
        adhocUser,
        permission,
        dateOfResponse,
        status,
        hocUsersList
    ) {

        return {
            selectRow,
            approverId,
            approverName,
            adhocUser,
            permission,
            dateOfResponse,
            status,
            hocUsersList
        };
    }

    async function formatReturnData() {
        var listOfObjects = [];
        const arrList = objectDataToInitiatorView['approvers']
        //console.log(arrList)
        for (let i = 0; i < arrList.length; i++) {
            listOfObjects.push(
                setReturnData(
                    arrList[i],
                    arrList[i]['_id'],
                    arrList[i]['approver']['name'],
                    arrList[i]['hockUser'] == null ? null : arrList[i]['hockUser']['name'],
                    arrList[i]['permission'],
                    await setResponseTime(arrList[i]['approverResponseTime'], arrList[i]['hockResponseTime']),
                    arrList[i]['approverStatus'],
                    await getAdHocUsersList(arrList[i]['approver']['_id'])

                )
            )
        }
        //console.log(listOfObjects)
        setReturnDataSource(listOfObjects)
    }

    async function setResponseTime(param1, param2) {
        if (param1 == null) {
            if (param2 == null) {
                return null;
            } else {
                return param2
            }
        } else {
            return param1
        }
    }

    function setHocUsers(
        //key, 
        label,
        value) {

        return {
            //key, 
            label,
            value,
        };
    }

    async function getAdHocUsersList(approverId) {
        //console.log(approverId)
        var listOfObjects = [];
        var arrList = await WorkflowManagementAPI.getAdHocUsers(approverId, companyId, token).then((res) => {
            return res.data
        })
        //console.log(arrList)

        for (let i = 0; i < arrList.length; i++) {
            listOfObjects.push(
                setHocUsers(
                    //i,
                    arrList[i]['signatoriesId']['name'],
                    arrList[i]['signatoriesId']['_id'],
                )
            )
        }
        return listOfObjects
    }

    function getApproveUserAAOT(data) {
        if (data['leaveStatus']) {
            return 'Half Day';
        } else {
            return 'Available';
        }
    }


    const columns = [
        {
            title: 'Approver Id',
            dataIndex: 'approverId',
            key: 'approverId',
            hidden: true
        },
        {
            title: 'Approver Name',
            dataIndex: 'approverName',
            key: 'approverName',
            render: (approverName, record) => (
                //console.log(record),
                <Flex align='center' gap={16}>
                    <span>{approverName}</span>
                    {record.primaryUserApproved && <CheckCircleOutlined style={{ color: colorPrimary }} />}
                </Flex>
            ),
        },
        {
            title: 'Alternative Signatory',
            dataIndex: 'adhocUser',
            key: 'adhocUser',
            render: (adhocUser, record) => (
                adhocUser ? (
                    // < Select
                    //     defaultValue={adhocUser}
                    //     style={{ width: '100%' }}
                    //     onChange={(value) => {
                    //         handleChange(value)
                    //         //record.adhocUser = value;
                    //         setEditedRow(record.key);
                    //     }}
                    //     //options={record['hocUsersList']}
                    // />
                    <Flex align='center' gap={16}>
                        <span>{adhocUser}</span>
                        {record.adhocUserApproved && <CheckCircleOutlined style={{ color: colorPrimary }} />}
                    </Flex>
                ) : (
                    < Select
                        placeholder="Select User"
                        defaultValue={adhocUser}
                        style={{ width: '100%' }}
                        onChange={(value) => {
                            handleChange(record, value)
                            //record.adhocUser = value;
                            setEditedRow(record.selectRow);
                        }}
                        options={record['hocUsersList']}
                    />
                )

            ),
        },
        {
            title: 'Permission',
            dataIndex: 'permission',
            key: 'permission',
            //align: 'center',
            render: (permission) => {
                //const color = permission === 'approve' ? 'green' : 'yellow';
                if (permission == 'approve') {
                    //return <Tag color={color}>Approve</Tag>;
                    return 'Approve'
                } else if (permission == 'view') {
                    //return <Tag color={color}>View</Tag>;
                    return 'View'
                }
            },
        },
        {
            title: 'AAOT',
            dataIndex: ['leaveStatus'],
            key: 'aaot',
            render: (aaot, record) => {
                const color = aaot === 'On leave' ? 'red' : 'green';
                return <Tag color={color}>{getApproveUserAAOT(record)}</Tag>;
            },
        },
        {
            title: 'Responded At',
            dataIndex: 'dateOfResponse',
            key: 'dateOfResponse',
            render: (dateOfResponse) => (
                dateOfResponse === 'Pending' ? (
                    <Tag color="orange">Pending</Tag>
                ) : (
                    <span>{dateOfResponse}</span>
                )
            ),
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                //const color = status === 'approved' ? 'green' : status === 'Pending' ? 'orange' : 'red';

                if (status == 'pending') {
                    return <Tag color='orange'>Pending</Tag>;
                } else if (status == 'rejected') {
                    return <Tag color='red'>Rejected</Tag>;
                } else if (status == 'approved') {
                    return <Tag color='green'>Approved</Tag>;
                }

            },
        },
    ];

    const handleChange = (record, value) => {
        //console.log(`selected ${value}`);
        //console.log(record.approverId)
        //console.log(record)
        var setListObject = {}

        //debugger
        var setListObject = {
            approverId: record.approverId,
            hocUserId: value
        }

        if (list.length == 0) {
            setList(prevList => [...prevList, setListObject]);
        } else {
            for (const element of list) {
                if (element.approverId === record.approverId) {
                    element.hocUserId = value
                }
                else {
                    setList(prevList => [...prevList, setListObject]);
                }
            }
        }
    };

    const saveButton = async () => {
        for (const element of list) {
            var formData = {
                hockUserId: element.hocUserId
            }
            try {
                await WorkflowManagementAPI.addHocUser(objectDataToInitiatorView._id, element['approverId'], companyId, token, formData).then((res) => {
                    navigate('/work-flow/circuler')
                })
            } catch (error) {
                messageApi.open({
                    type: 'error',
                    content: error.response.data.message,
                });
            }
        }
    }

    return (
        <>
            {contextHolder}

            <Flex gap={20} justify='space-between' align='center' style={{
                margin: '16px',
                padding: '16px 24px',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
            }}>
                <Breadcrumb
                    items={[
                        {
                            //href: '',
                            title: <FileWordOutlined />,

                        },
                        {
                            title: 'Workflow',
                        },
                        {
                            href: goBack,
                            title: 'Circulation',
                            onClick: goBack
                        },
                        {
                            title: 'View',
                        },
                    ]}
                />
            </Flex>

            <Card
                bordered={false}
                style={{
                    margin: '16px',
                    // padding: 24,
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
                title={
                    <Flex align='center' justify='space-between'>
                        <Text>Request</Text>
                        <Button
                            type='primary'
                            onClick={() => 
                                // navigate('/work-flow/view-circuler', { state: { objectDataToFullCirculerView: objectDataToInitiatorView } })
                                navigate('/work-flow/view-circuler', { state: { tabValue: 2, approvalId: objectDataToInitiatorView._id } })
                            }
                        >View Full Circular</Button>
                    </Flex>
                }
            >
                <Row gutter={24}>
                    <Col span={12}>
                        <Flex align='center' justify='flex-start' gap={16}>
                            <Text strong>Requested Date & Time : </Text>
                            <Text>{objectDataToInitiatorView.createdAt}</Text>
                        </Flex>
                    </Col>
                    <Col span={12}>
                        <Flex align='center' justify='flex-start' gap={16}>
                            <Text strong>Request Type : </Text>
                            <Text >{objectDataToInitiatorView.requestType.requestType}</Text>
                        </Flex>
                    </Col>
                </Row>
                <br />
                <Row gutter={24}>
                    <Col span={12}>
                        <Flex align='center' justify='flex-start' gap={16}>
                            <Text strong>Requester Name : </Text>
                            <Text >{objectDataToInitiatorView.createdBy.name}</Text>
                        </Flex>
                    </Col>
                    <Col span={12}>
                        <Flex align='center' justify='flex-start' gap={16}>
                            <Text strong>Number of Approvers : </Text>
                            <Text >{objectDataToInitiatorView.approvers.length}</Text>
                        </Flex>
                    </Col>
                </Row>
                <br />
            </Card>

            <div
                style={{
                    margin: '16px',
                    padding: '24px',
                    background: colorBgContainer,
                    borderRadius: borderRadiusLG,
                }}
            >

                <Table
                    dataSource={returnDataSource}
                    columns={columns}
                    pagination={false}
                // onRow={(record) => ({

                //     onClick: (e) => {
                //         const cell = e.target.closest('td');
                //         const row = cell.parentElement;
                //         handleRowClick(record, cell.cellIndex);
                //     },
                // })}
                />

                {editedRow && (
                    <div style={{ marginTop: 16 }}>
                        <Flex justify="flex-end">
                            <Button type="primary" onClick={() => {
                                setEditedRow(null);
                                //console.log("Changes saved for row:", editedRow);
                                saveButton()
                            }}>
                                Save Changes
                            </Button>
                        </Flex>
                    </div>
                )}
            </div>
        </>
    );
}
